// frontend/utils/api.ts

/**
 * 백엔드 API 기본 URL.
 * .env.local의 NEXT_PUBLIC_API_URL 값만 사용하며, 하드코딩된 주소는 허용하지 않습니다.
 */
export const API_URL = process.env.NEXT_PUBLIC_API_URL as string;

if (!API_URL && typeof window !== "undefined") {
  console.error("[AlphaNote:API] NEXT_PUBLIC_API_URL 환경 변수가 설정되지 않았습니다.");
}

/**
 * JSON 요청에 필요한 Content-Type + Authorization 헤더를 반환합니다.
 * POST / PATCH / PUT 요청에 사용합니다.
 */
export function authHeaders(accessToken?: string): HeadersInit {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken ?? ""}`,
  };
}

/**
 * Content-Type 없이 Authorization 헤더만 반환합니다.
 * GET / DELETE 처럼 바디가 없는 요청에 사용합니다.
 */
export function authOnlyHeaders(accessToken?: string): HeadersInit {
  return {
    Authorization: `Bearer ${accessToken ?? ""}`,
  };
}

/**
 * 실패한 API 응답에서 사람이 읽을 수 있는 에러 메시지를 추출합니다.
 * 응답 바디의 error → message → fallback 순으로 확인합니다.
 */
export async function extractApiError(res: Response, fallback: string): Promise<string> {
  try {
    const data = await res.json();
    return data.error || data.message || fallback;
  } catch {
    return fallback;
  }
}



/** 서버의 Bearer·HttpOnly 쿠키 세션을 폐기한다. 실패해도 호출부가 로컬 로그아웃을 진행한다. */
export async function revokeServerSession(accessToken?: string): Promise<void> {
  try {
    await fetch(`${API_URL}/auth/logout`, {
      method: "POST",
      headers: authOnlyHeaders(accessToken),
      credentials: "include",
    });
  } catch {
    // 네트워크가 끊겨도 NextAuth 로그아웃은 계속 진행한다.
  }
}
